export enum EKwikUIInputSelectSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputSelectSize = [
  EKwikUIInputSelectSize.S,
  EKwikUIInputSelectSize.M,
  EKwikUIInputSelectSize.L
] as const;

export type TKwikUIInputSelectSize = (typeof VKwikUIInputSelectSize)[number];
